import { ProductStats } from "action/stat-action";

const Product = ({ product }: { product: ProductStats }) => {
  const { image_url, price, name } = product;
  return (
    <div className="bg-default-50  p-4 rounded-[14px] text-center">
      <div className="h-12 w-12 rounded-full mb-4 mx-auto">
        <img
          src={image_url ?? ""}
          alt=""
          height={100}
          width={100}
          className="w-full h-full rounded-full"
        />
      </div>
      <div className="text-default-500 text-sm mb-1  font-normal">
        {" "}
          ₦{price}{" "}
      </div>
      <div className="text-default-600 text-sm mt-5 mb-1">{name}</div>
    </div>
  );
};

export default Product;
